import React, { useContext, useEffect, useState } from 'react'
import useSWR from 'swr'
import { Paper } from '@mui/material'

import { orderRepository, meRepository } from '~/src/repositories'
import { useMessage } from '~/src/hooks'
import { CountContext } from '~/src/routes'
import { IPostRequestOrderMessageRequestBody } from '~/src/repositories/Order/models/Order'
import { MessageList as MessageListComponent } from '~/src/components/molecules'
import { MessageForm } from '~/src/components/organisms/ContainerOrder/Message/MessageForm'
import { useRequestOrderMessages } from '~/src/hooks/useRequestOrderMessages'

interface IMessageListProps {
  id: string
}

/**
 * MessageList
 * @param id
 */
export const MessageList: React.FC<IMessageListProps> = ({ id }): JSX.Element => {
  const { handleOpenWithErrorMessage, handleOpenWithSuccessMessage } = useMessage()
  const [isPosting, setIsPosting] = useState<boolean>(false)
  const [isDeleting, setIsDeleting] = useState<boolean>(false)
  const { data, isLoading, isError, isValidating, mutate } = useRequestOrderMessages(id)
  const { data: readResult } = useSWR(isValidating ? null : `/request-orders/${id}/read`, () => orderRepository.patchRequestOrderItemRead(id))

  const { setCount } = useContext(CountContext)
  const { data: countData } = useSWR(readResult ? '/me/status' : null, () => meRepository.getMeStatus())
  if (typeof countData?.data.unreadRequestOrdersCount !== 'undefined') {
    setCount(countData?.data.unreadRequestOrdersCount)
  }

  useEffect(() => {
    if (isError) handleOpenWithErrorMessage('メッセージの取得に失敗しました')
  }, [isError])

  /**
   * onSubmitMessage
   * @param values
   */
  const onSubmitMessage = async (values: IPostRequestOrderMessageRequestBody) => {
    try {
      setIsPosting(true)
      await orderRepository.postRequestOrderMessage(Number(id), values)
      await mutate()
      handleOpenWithSuccessMessage('送信しました')
    } catch (e: any) {
      handleOpenWithErrorMessage(e.message)
    } finally {
      setIsPosting(false)
    }
  }

  const onDeleteMessage = async(execute = false, commentId: number) => {
    if(execute) {
      try {
        setIsDeleting(true)
        await orderRepository.deleteRequestOrderMessages([commentId])
        await mutate()
        handleOpenWithSuccessMessage('削除しました')
      } catch (e: any) {
        handleOpenWithErrorMessage(e.message)
      } finally {
        setIsDeleting(false)
      }
    }
  }

  return (
    <Paper>
      <MessageListComponent id={id} messages={data?.messages || []} isLoading={isLoading} onDeleteMessage={onDeleteMessage}/>
      <MessageForm onSubmit={onSubmitMessage} isPosting={isPosting} />
    </Paper>
  )
}
